import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/16_card_back_crowned_dog/16_card_back_crowned_dog"
 * Contains 1 texture(s)
 */
export class CardsBacks16CardBackCrownedDogAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/16_card_back_crowned_dog/16_card_back_crowned_dog';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '16_crowned_dog.png'
    ] as const;
}
